import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { IN_HOME_USER_EVENTS } from "../lib/events";
import { ScreeningSurveyInfoLayout } from "./components/ScreeningSurveyInfoLayout";

export function ScreeningSurveyWaitlist() {
  useLogEffect(IN_HOME_USER_EVENTS.SCREENING_SURVEY_WAITLIST_PAGE_VIEWED);

  return (
    <ScreeningSurveyInfoLayout title="Thanks for Applying!" icon="hourglass-illustration">
      <Text
        variant="h3"
        sx={(theme) => ({ textAlign: "center", color: theme.palette.text.secondary })}
      >
        We'll be in touch when there are opportunities nearby!
      </Text>
    </ScreeningSurveyInfoLayout>
  );
}
